import { ICancellationToken } from '../contracts/cancellation/cancellation-token';
import { ObservableModel } from '../viewmodel/observable-model';

export class CancellationToken implements ICancellationToken {
  public promise: Promise<void>;
  public cancelled: ObservableModel<boolean>;
  // Retry counter per service while it is being retried (see ICancellationToken.serviceRepeats).
  public serviceRepeats?: Record<string, number> = {};
  // Per service: synced ALL data successfully - drives attachment ordering + completedData, NOT the
  // indicator close (see ICancellationToken.syncCompleted).
  public syncCompleted?: Record<string, boolean> = {};
  // Per service: reached any terminal state (success/error/cancel/ignored) - drives the sync
  // indicator close (see ICancellationToken.syncTerminal).
  public syncTerminal?: Record<string, boolean> = {};

  constructor() {
    this.cancelled = new ObservableModel(false, false);
  }

  public async cancel(): Promise<void> {
    this.cancelled.set(true);
    if (this.promise && this.promise.then) {
      await this.promise;
    }
  }

  public reset(): ICancellationToken {
    this.cancelled = new ObservableModel(false, false);
    this.promise = undefined;

    return this;
  }
}
